<template>
  <span>
    <confirm-btn
      v-show="row.status === 0"
      btnType="warning"
      btnClass=""
      btnIcon=""
      msgBase="api.actions.sendSOAEmail."
      reqPath="/soa/email/send"
      :reqData="{id:[row.doc_id], is_ref_key: true}"
      :after="refreshList"
      :tip="$t('api.actions.sendSOAEmail.btnTip')"
      :infoText="$t('api.actions.sendSOAEmail.infoText', {number: row.number})"
    >
      <svg-icon icon-class="baseline-send-24px"></svg-icon>
    </confirm-btn>
    <el-tooltip
      class="item"
      effect="dark"
      placement="top-end"
      :content="(row.is_email_sent) ?
        $t('api.actions.sendSOAEmail.emailIsSent') :
        $t('api.actions.sendSOAEmail.emailNotSent')"
    >
      <el-button
        :type="(row.is_email_sent) ? 'success' : 'primary'"
        size="small"
        icon="el-icon-message"
        @click="$router.push({
          path: '/chart/soa/email/list?doc_id=' + row.doc_id
        })"
      >
      </el-button>
    </el-tooltip>
    <confirm-btn
      v-show="row.status === 0"
      btnType="danger"
      btnIcon=""
      btnClass=""
      msgBase="api.actions.voidDocument."
      :actFn="defUpdate"
      :resFn="confirmVoidRes"
      :reqPath="`/soa/${soaPathName}/${row.doc_id}/void`"
      :reqData="{}"
      :after="refreshList"
      :tip="$t('api.actions.voidDocument.btnTip')"
      :infoText="$t('api.actions.voidDocument.infoText', {number: row.number, branch_name: row.branch_name})"
    >
      <svg-icon icon-class="baseline-not_interested-24px"></svg-icon>
    </confirm-btn>
  </span>
</template>

<script>

import { defUpdate } from '@/api/default'
import { confirmVoidRes } from '@/utils/void_soa_doc'

export default {
  name: 'soa-btns',
  props: {
    row: {
      type: Object,
      required: true
    },
    refreshList: {
      type: Function,
      required: true
    },
    soaPathName: {
      type: String,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    defUpdate,
    confirmVoidRes
  }
}

</script>
